import { FormGroup } from "@angular/forms";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { DocumentosBeneficiario } from "./documentos-beneficiario";
import { DocumentosConyuge } from "./documentos-conyuge";
import { DocumentosParentesco } from "./documentos-parentesco";
import { DocumentosTrabajador } from "./documentos-trabajador";


export class ObtenerDocumentosObligatoriosFactory {
    private static documentos: Record<string, new (p: FormGroup, f: FormGroup, s: ObligatoriedadDocumentosService) => DocumentosParentesco> = {
        beneficiario: DocumentosBeneficiario,
        trabajador: DocumentosTrabajador,
        conyuge: DocumentosConyuge,
    };

    static obtenerDocumentos(
        tipoPersona: string, 
        personaControl: FormGroup, 
        formulario: FormGroup, 
        documentosService: ObligatoriedadDocumentosService
    ): DocumentosParentesco {
        const DocumentosClass = this.documentos[tipoPersona.toLowerCase()];
        
        if (!DocumentosClass) {
            throw new Error(`Tipo de persona no soportado: ${tipoPersona}`);
        }

        return new DocumentosClass(personaControl, formulario, documentosService);
    }
}
